import React, { useEffect, useMemo, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchCategories, fetchTracks, fetchReciters } from "../lib/api";
import TrackCard from "../components/TrackCard";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

export default function Category() {
  const { slug } = useParams();
  const [categories, setCategories] = useState([]);
  const [reciters, setReciters] = useState([]);
  const [tracks, setTracks] = useState([]);
  const [reciter, setReciter] = useState("all");
  const [type, setType] = useState("all");

  useEffect(() => {
    fetchCategories().then(setCategories).catch(() => {});
    fetchReciters().then(setReciters).catch(() => {});
  }, []);

  useEffect(() => {
    const params = { category: slug, limit: 100 };
    if (reciter !== "all") params.reciter = reciter;
    if (type !== "all") params.type = type;
    fetchTracks(params).then(setTracks).catch(() => {});
  }, [slug, reciter, type]);

  const cat = useMemo(() => categories.find((c) => c.slug === slug), [categories, slug]);

  return (
    <div data-testid="category-page">
      {/* Header */}
      <section className="relative border-b border-white/5">
        <div className="absolute inset-0">
          {cat?.thumbnail && <img src={cat.thumbnail} alt="" className="w-full h-full object-cover opacity-30" />}
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B]/60 via-[#0A0A0B]/80 to-[#0A0A0B]" />
        </div>
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
          <Link to="/" className="overline text-[#B79C7B] hover:text-ivory">← Back to Home</Link>
          <h1 className="font-serif text-5xl lg:text-6xl text-ivory mt-6 leading-none">{cat?.name || "Category"}</h1>
          {cat?.description && <p className="mt-4 max-w-2xl text-[#A1A1AA]">{cat.description}</p>}
        </div>
      </section>

      {/* Filters */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-8 flex flex-wrap items-center gap-4 border-b border-white/5">
        <div className="overline text-[#71717A]">Filters</div>
        <Select value={reciter} onValueChange={setReciter}>
          <SelectTrigger className="w-56 bg-[#121214] border-[#2A2A2D]" data-testid="filter-reciter">
            <SelectValue placeholder="All Reciters" />
          </SelectTrigger>
          <SelectContent className="bg-[#121214] border-[#2A2A2D] text-ivory">
            <SelectItem value="all">All Reciters</SelectItem>
            {reciters.map((r) => <SelectItem key={r.id} value={r.id}>{r.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={type} onValueChange={setType}>
          <SelectTrigger className="w-40 bg-[#121214] border-[#2A2A2D]" data-testid="filter-type">
            <SelectValue placeholder="All Types" />
          </SelectTrigger>
          <SelectContent className="bg-[#121214] border-[#2A2A2D] text-ivory">
            <SelectItem value="all">All Types</SelectItem>
            <SelectItem value="audio">Audio</SelectItem>
            <SelectItem value="video">Video</SelectItem>
          </SelectContent>
        </Select>
        <div className="text-sm text-[#71717A] ml-auto">{tracks.length} items</div>
      </section>

      {/* Grid */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
        {tracks.length === 0 ? (
          <div className="text-center text-[#71717A] py-20" data-testid="empty-tracks">No items yet in this section.</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5">
            {tracks.map((t) => <TrackCard key={t.id} track={t} />)}
          </div>
        )}
      </section>
    </div>
  );
}
